import permissions from '../../data/permissions';

export default [
    {
        name: "PurchaseInvoiceCreate",
        path: "invoice",
        component: () => import('./../../views/purchase/PurchaseInvoiceCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.invoice.create }
    },
    {
        name: "PurchaseInvoiceDisplay",
        path: "invoice/:id",
        component: () => import('./../../views/purchase/PurchaseInvoiceDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.invoice.read }
    },
    {
        name: "PurchaseInvoiceEdit",
        path: "invoice/:id/edit",
        component: () => import('./../../views/purchase/PurchaseInvoiceEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.invoice.update }
    },
    {
        name: "PurchaseInvoiceList",
        path: "invoices",
        component: () => import('./../../views/purchase/PurchaseInvoiceListView.vue'),
        meta: { requiresAuth: true, authorization: permissions.invoice.index }
    }
];